// extracted by mini-css-extract-plugin
export default {"Container":"EmptyState_Container__kgGRm"};